import React, { useEffect, useState } from "react";
import first1 from "../../assets/images/leaderboard-profile.jpg";
import { Tabs } from "antd";
import { NavLink } from "react-router-dom";
import Main from "../../components/layout/Main";
import { useAuth } from "../../context/AuthContext";
import { isValidUrl } from "../../helper/functions";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

function ConnectionIndex() {
  // -------- constants ------------
  const { getConnections } = useAuth();
  const [connectionData, setConnectionData] = useState();
  const [activeTab, setActiveTab] = useState("1");
  const [query, setQuery] = useState({ filter: "followers" });
  const location = useLocation();
  const data = location.state?.data || "followers";
  const [searchParams] = useSearchParams();
  const id = searchParams.get("userId");

  // -------- handlers -------------
  const fetchConnections = async () => {
    try {
      const response = await getConnections(query);
      setConnectionData(response.data.data);
    } catch (error) {
      console.log(error, "error");
    }
  };

  // -------- Tabs --------
  const tabItems = [
    {
      key: "1",
      label: <span className="tab-one">Followers</span>,
      children: (
        <div>
          {connectionData?.map((item, index) => (
            <div className="followers-div-flex" key={index}>
              <div className="followers-first-div">
                <div className="img-followers-div">
                  <img
                    src={
                      isValidUrl(item?.profilePic)
                        ? item?.profilePic
                        : first1 || first1
                    }
                    alt="follower"
                  />
                </div>
                <div className="follwers-text-div2">
                  <h6>{item?.name}</h6>
                  <p>{item?.username}</p>
                </div>
              </div>
              <div className="profile-text-link">
                <NavLink to={`/profile/${item?._id}`}>Profile</NavLink>
              </div>
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "2",
      label: <span className="tab-one">Following</span>,
      children: (
        <div>
          {connectionData?.map((item, index) => (
            <div className="followers-div-flex" key={index}>
              <div className="followers-first-div">
                <div className="img-followers-div">
                  <img src={item?.profilePic || first1} alt="follower" />
                </div>
                <div className="follwers-text-div2">
                  <h6>{item?.name}</h6>
                  <p>{item?.username}</p>
                </div>
              </div>
              <div className="profile-text-link">
                <NavLink to={`/profile/${item?._id}`}>Profile</NavLink>
              </div>
            </div>
          ))}
        </div>
      ),
    },
  ];

  // ------- use effect --------
  useEffect(() => {
    if (data === "following") {
      setActiveTab("2");
      setQuery({ filter: "following", id: id });
    } else {
      setActiveTab("1");
      setQuery({ filter: "followers", id: id });
    }
  }, [data, id]);

  useEffect(() => {
    fetchConnections();
    // eslint-disable-next-line
  }, [query]);
  return (
    <>
      <Main>
        <section className="section-main">
          <div className="follwer">
            <div className="main-context-div">
              <div className="orange-header">Connections</div>
              <Tabs
                activeKey={activeTab}
                items={tabItems}
                className="custom-tabs"
                onChange={(key) => {
                  setActiveTab(key);
                  setQuery({
                    filter: key === "1" ? "followers" : "following",
                    id,
                  });
                }}
              />
            </div>
          </div>
        </section>
      </Main>
    </>
  );
}

export default ConnectionIndex;
